export const testResultConstants = {
    GETFAILURES_REQUEST: 'TESTRESULTSGETFAILURES_REQUEST',
    GETFAILURES_SUCCESS: 'TESTRESULTSGETFAILURES_SUCCESS',
    GETFAILURES_FAILURE: 'TESTRESULTSGETFAILURES_FAILURE',

    FLUSHFAILURES_REQUEST: 'TESTRESULTSFLUSHFAILURES_REQUEST',
    FLUSHFAILURES_SUCCESS: 'TESTRESULTSFLUSHFAILURES_SUCCESS',
    FLUSHFAILURES_FAILURE: 'TESTRESULTSFLUSHFAILURES_FAILURE'
};